export default function getUrlParams(name) {
  const search =
    window.location.search.substr(1) || window.location.hash.split('?')[1]
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  const r = search?.match(reg)
  if (r != null) return unescape(r[2])
  return null
}
